import { getMapLocations } from './map.action';

export { mapReducer } from './map.reducer';
export { watchMap } from './map.saga';

export const mapActions = {
    getMapLocations,
};
